import _extends from "@swc/helpers/src/_extends.mjs";
/* No DS :( */ import React from 'react';
import IconWrap from '../IconWrap';
const ThemeSwitchLight = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({
        disableDefaultColors: true
    }, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 30"
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("circle", {
        id: "ThemeSwitchLight-circle",
        cx: "15",
        cy: "15",
        r: "11"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "ThemeSwitchLight-mask",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#ThemeSwitchLight-circle"
    })), /*#__PURE__*/ React.createElement("use", {
        fill: "#EAEAEA",
        transform: "matrix(1 0 0 -1 0 30)",
        xlinkHref: "#ThemeSwitchLight-circle"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#22272B",
        d: "M20.597 17L30.8 25.705l-10.111 2.331.263.241-1.415.024L4.19 31.84 7.879 28.5-1 28.654l12.042-9.483 2.659 2.444-6.524 5.837 1.864-.001L20.597 17z",
        mask: "url(#ThemeSwitchLight-mask)",
        transform: "matrix(-1 0 0 1 29.8 0)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "14.864",
        cy: "12.5",
        r: "2.5",
        fill: "#292F34",
        mask: "url(#ThemeSwitchLight-mask)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "15",
        cy: "15",
        r: "14",
        stroke: "transparent",
        strokeWidth: "2"
    }))));
ThemeSwitchLight.displayName = 'ThemeSwitchLight';
export default ThemeSwitchLight;
